module.exports = __webpack_public_path__ + "static/img/gaga.7a7497de.png";